'use strict';

const _ = require('underscore');
const Moment = require('moment');
const Backbone = require('backbone');

/**
 * スケールによって、日時と x 軸の対応付けを行うクラス
 */
class DateTimeScale {
    constructor(unitDays, scaleDays, rootDateTime, offsetX) {
        this._unitDays = unitDays;
        this._scaleDays = scaleDays;
        this._unitScale = 60 * 60 * 24 * this._scaleDays / 640;
        this._rootDateTime = rootDateTime;
        this._offsetX = offsetX;
    }

    /* 起点の日時を返す */
    getRootDateTime() {
        return this._rootDateTime;
    }

    /* 起点の日時を戻す */
    prev() {
        this._rootDateTime.subtract(this._unitDays, 'day');
    }

    /* 起点の日時を今日にする */
    today() {
        this._rootDateTime = Moment(0, 'HH');
    }

    /* 起点の日時を進める */
    next() {
        this._rootDateTime.add(this._unitDays, 'day');
    }

    /* 日時に対応した x 軸座標を返す */
    locateX(dateTime) {
        const duration = dateTime.diff(this._rootDateTime, 'seconds');
        return duration / this._unitScale + this._offsetX;
    }

    /* x 軸座標に対応した日時を返す */
    dateTime(x) {
        const duration = (x - this._offsetX) * this._unitScale;
        return this._rootDateTime.clone().add(duration, 'seconds');
    }

    /* x 軸座標の範囲に対応した日のコレクションを返す */
    getDateCollectionBetween(fromX, toX) {
        const fromDateTime = this.dateTime(fromX);
        const toDateTime = this.dateTime(toX);
        const range = toDateTime.diff(fromDateTime, 'days');

        return new Backbone.Collection(
            _.map(_.range(0, range), i => {
                return new Backbone.Model({
                    date: this._rootDateTime.clone().add(i, 'days')
                })
            })
        );
    }
}

module.exports = DateTimeScale;



// WEBPACK FOOTER //
// ./common/ui/view/svg/gantt/date-time-scale.js